// extracted by mini-css-extract-plugin
export var container = "_h0-1";
export var cornerButtonContainer = "_h0-6";
export var disabled = "_h0-2";
export var dragActive = "_h0-3";
export var fileContainer = "_h0-5";
export var hiddenInput = "_h0-4";
export var widthContainer = "_h0-0";